import { useState, useEffect } from 'react';
import { portalApi } from '../../api';

export default function PortalNotifications() {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    portalApi('/notifications').then(setList).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const read = (id: number) => {
    portalApi(`/notifications/${id}/read`, { method: 'POST' }).catch(() => {});
    setList((l) => l.map((n) => (n.id === id ? { ...n, is_read: 1 } : n)));
  };
  const readAll = () => {
    portalApi('/notifications/read-all', { method: 'POST' }).then(load).catch(() => {});
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-emerald-800">🔔 消息通知</h2>
        {list.length > 0 && (
          <button onClick={readAll} className="text-xs text-emerald-600 hover:underline">全部已读</button>
        )}
      </div>
      {loading && <div className="text-slate-400 text-sm">加载中…</div>}
      {!loading && list.length === 0 && <div className="text-slate-400 text-sm">暂无消息</div>}
      {list.map((n) => (
        <div
          key={n.id}
          onClick={() => read(n.id)}
          className={`bg-white rounded-xl shadow-sm p-3 border ${n.is_read ? 'border-slate-100' : 'border-emerald-300 border-l-4'}`}
        >
          <div className="flex items-center justify-between">
            <div className="font-medium">{n.title}</div>
            {!n.is_read && <span className="w-2 h-2 rounded-full bg-red-500" />}
          </div>
          {n.content && <div className="text-sm text-slate-500 mt-1">{n.content}</div>}
          <div className="text-xs text-slate-400 mt-1">{(n.created_at || '').slice(0, 19).replace('T', ' ')}</div>
        </div>
      ))}
    </div>
  );
}
